import { Component, OnInit, Input } from '@angular/core';

import {BemSubtipo} from "../shared/bem-subtipo.model";
import {bemSubtiposModuleName} from "../shared/data.service";

@Component({
  selector: 'app-bem-subtipos-list',
  template: require('./bem-subtipos-list.component.html'),
  styles: [require('./bem-subtipos-list.component.css')]
})
export class BemSubtiposListComponent implements OnInit {
  @Input() showDisabled: boolean = true;
  @Input() list: BemSubtipo[] = [];

  bemSubtiposModule: any = bemSubtiposModuleName;

  constructor() { }

  ngOnInit() {
  }

}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/bens/bem-subtipos/bem-subtipos-list/bem-subtipos-list.component.ts
 **/